"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _utils = require("../../../../../../../common/utils");

require("../styles/_asset-selection-header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var SMALL_BREAKPOINT = 640;

function getDropdownOptionsFromLabels(labels) {
  return [{
    label: 'ALL LABELS',
    value: 'ALL'
  }].concat(_toConsumableArray(labels.filter(function (_ref) {
    var label = _ref.label;
    return Boolean(label);
  }).map(function (_ref2) {
    var label = _ref2.label;
    return {
      label: label,
      value: label
    };
  })));
}

function AssetSelectionHeader(_ref3) {
  var size = _ref3.size,
      videoAssets = _ref3.videoAssets,
      selectedAssets = _ref3.selectedAssets,
      filteredAssets = _ref3.filteredAssets,
      onBulkRemoveAssetsFromProject = _ref3.onBulkRemoveAssetsFromProject,
      onBulkRemoveAssetsFromVideo = _ref3.onBulkRemoveAssetsFromVideo,
      onBulkDeleteAssets = _ref3.onBulkDeleteAssets,
      onBulkArchiveAssets = _ref3.onBulkArchiveAssets,
      hasDeleteAssetsPermission = _ref3.hasDeleteAssetsPermission,
      hasArchiveAssetsPermission = _ref3.hasArchiveAssetsPermission,
      setLabelFilter = _ref3.setLabelFilter,
      labels = _ref3.labels,
      labelFilter = _ref3.labelFilter,
      toggleSelectAllAssets = _ref3.toggleSelectAllAssets,
      canUpdateVideo = _ref3.canUpdateVideo,
      onBulkEditLabel = _ref3.onBulkEditLabel,
      onBulkEditTags = _ref3.onBulkEditTags;
  var hiddenSelected = selectedAssets.filter(function (assetId) {
    return !filteredAssets.includes(assetId);
  });
  var hiddenSelectedDisplayString = hiddenSelected.length ? "( ".concat(hiddenSelected.length, " HIDDEN )") : '';
  var bulkOptions = [{
    action: onBulkRemoveAssetsFromVideo,
    label: 'REMOVE FROM VIDEO'
  }, {
    action: onBulkRemoveAssetsFromProject,
    label: 'REMOVE FROM PROJECT'
  }, (0, _utils.optionalActionMenuItem)({
    action: onBulkArchiveAssets,
    label: "ARCHIVE ASSET".concat(selectedAssets.length === 1 ? '' : 'S')
  }, hasArchiveAssetsPermission), (0, _utils.optionalActionMenuItem)({
    action: onBulkDeleteAssets,
    isRed: true,
    label: "DELETE ASSET".concat(selectedAssets.length === 1 ? '' : 'S')
  }, hasDeleteAssetsPermission)];
  return (/*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('asset-selection-header', {
        'asset-selection-header--small': size.width < SMALL_BREAKPOINT
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "asset-selection-header__left"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      name: "medialibrary",
      size: 20,
      color: "russian"
    }), /*#__PURE__*/_react.default.createElement("p", null, "Video Assets (".concat(videoAssets.length, ")")), canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_uiKit.BulkActions, {
      darkMode: true,
      totalItems: videoAssets.length,
      selectedItems: selectedAssets.length,
      onSelectAll: toggleSelectAllAssets,
      suffix: hiddenSelectedDisplayString,
      actions: [{
        icon: /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
          key: "bulk-remove",
          popupBtn: /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
            hoverColor: "regent",
            color: "white",
            name: "trash",
            size: 20
          }),
          options: bulkOptions
        }),
        id: 'delete',
        label: 'Remove'
      }, {
        icon: 'label',
        action: onBulkEditLabel,
        label: 'Edit Labels'
      }, {
        icon: 'tags',
        action: onBulkEditTags,
        label: 'Edit Tags'
      }]
    }) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: "asset-selection-header__right"
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Dropdown, {
      placeholder: "ALL LABELS",
      className: "asset-selection-header__right__dropdown",
      type: "BASIC",
      defaultValue: labelFilter,
      onChange: setLabelFilter,
      options: getDropdownOptionsFromLabels(labels),
      color: "white"
    }))))
  );
}

var _default = (0, _react.memo)(AssetSelectionHeader);

exports.default = _default;